document.addEventListener('DOMContentLoaded', () => {
  const blocks = document.querySelectorAll('[data-scroll-text]');
  if (!blocks.length) return;
  blocks.forEach(block => {
    const text = block.querySelector('.teaser_text');
    if (!text) return;

    const SPEED    = 0.3;
    const FRICTION = 0.92;

    let velocity    = 0;
    let extraOffset = 0;
    let rafId       = null;
    let lastScrollY = window.scrollY;

    // Duplique le texte pour un défilement infini continu
    text.innerHTML = text.innerHTML.trim() + '\u00A0\u00A0\u00A0\u00A0' + text.innerHTML.trim();

    // Largeur d'un exemplaire (la moitié du contenu dupliqué)
    function getHalf() {
      return text.scrollWidth / 2;
    }

    // Position de départ : on commence déjà à -half pour que le texte
    // soit visible depuis le centre, pas depuis le bord gauche
    let baseOffset = 0;

    function animate() {
      velocity    *= FRICTION;
      velocity = Math.max(-20, Math.min(20, velocity));
      
      extraOffset += velocity;

      // Boucle infinie : quand on dépasse une moitié, on repart
      const half = getHalf();
      extraOffset = ((extraOffset % half) + half) % half;

      text.style.transform = `translateX(${-(extraOffset)}px)`;

      if (Math.abs(velocity) > 0.05) {
        rafId = requestAnimationFrame(animate);
      } else {
        rafId = null;
      }
    }

    function isVisible() {
      const rect = block.getBoundingClientRect();
      return rect.bottom > 0 && rect.top < window.innerHeight;
    }

    function reset() {
      velocity = 0;
      lastScrollY = window.scrollY;
    }

    window.addEventListener('scroll', () => {
      const visible = isVisible();

      if (!visible) {
        reset();
        return;
      }

      const currentScrollY = window.scrollY;
      const delta = currentScrollY - lastScrollY;
      lastScrollY = currentScrollY;

      // évite les pics trop violents
      const clampedDelta = Math.max(-30, Math.min(30, delta));

      velocity += clampedDelta * SPEED;

      if (!rafId) {
        rafId = requestAnimationFrame(animate);
      }
    }, { passive: true });
  });
});